import { AxiosError } from "axios";
import { ProposalsResource } from "@repo/core/services/resources/proposals";

export const PHONE_ALREADY_REGISTERED_MESSAGE =
  "Esse telefone está sendo utilizado em outra conta. Digite um novo.";

export const PHONE_VALIDATION_UNAVAILABLE_MESSAGE =
  "Erro ao validar o telefone. Tente novamente.";

export type ValidatePhoneAgainstCpfResult =
  | { isValid: true }
  | { isValid: false; errorMessage: string };

export const getPhoneErrorFromApiResponse = (err: unknown): string | null => {
  if (err instanceof AxiosError && err.response?.data) {
    const data = err.response.data as Record<string, unknown>;
    const strMensagem = data.strMensagem as string | undefined;
    const message = data.message as string | undefined;
    const errorObj = data.error as { Message?: string } | undefined;
    return strMensagem || message || errorObj?.Message || null;
  }
  return null;
};

export const validatePhoneAgainstCpf = async (
  proposalsResource: ProposalsResource,
  ddd: string,
  phone: string,
  cleanCPF: string
): Promise<ValidatePhoneAgainstCpfResult> => {
  try {
    const { data: validatePhoneResponse } =
      await proposalsResource.validatePhoneNumber(ddd, phone, cleanCPF);

    if (validatePhoneResponse) {
      return {
        isValid: false,
        errorMessage: PHONE_ALREADY_REGISTERED_MESSAGE
      };
    }

    return { isValid: true };
  } catch (err) {
    const apiMessage = getPhoneErrorFromApiResponse(err);
    return {
      isValid: false,
      errorMessage: apiMessage || PHONE_VALIDATION_UNAVAILABLE_MESSAGE
    };
  }
};
